import React from 'react';
import {
  UsdCircleIcon,
  ClockIcon,
  DurationIcon,
  CoinIcon,
  StopwatchIcon,
} from '~svg/index';

const SortComponent = ({ componentName, color }) => {
  let components = {
    usdCircleIcon: UsdCircleIcon,
    clockIcon: ClockIcon,
    durationIcon: DurationIcon,
    coinIcon: CoinIcon,
    stopwatchIcon: StopwatchIcon,
  };
  const TagName = components[componentName];
  return (
    <TagName size={componentName === 'coinIcon' ? 17 : 14} color={color} />
  );
};
export default SortComponent;
